import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VaIconModule } from '@vendasta/uikit';

import { VaPricingModule } from '../pricing/pricing.module';

import { VaSalespersonDetailsComponent } from './salesperson-details.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, VaIconModule, VaPricingModule],
  declarations: [VaSalespersonDetailsComponent],
  exports: [VaSalespersonDetailsComponent],
})
export class VaSalespersonDetailsModule {}
